import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { GoalPermissionsHelper } from 'src/app/helpers/goal-permissions.helper';
import { RouteHelper } from 'src/app/helpers/route.helper';
import { IResultModel, ResultModel } from 'src/app/models/general/result.model';
import { GoalPeriod } from 'src/app/models/goalperiod.model';
import { ReviewPeriodAboutEmployeeResult } from 'src/app/models/review-period-aboutemployee-result.model';
import { GoalService } from 'src/app/services';
import { ErrorMessageService } from 'src/app/shared/services';

@UntilDestroy()
@Component({
  selector: 'app-goal-competency-result-selector',
  templateUrl: './goal-competency-result-selector.component.html',
  styleUrl: './goal-competency-result-selector.component.scss'
})
export class GoalCompetencyResultSelectorComponent implements OnInit {

  @Input() 
  public goalPeriod: GoalPeriod;

  public gaugeSize: number = 62;
  public gaugeThick: number = 3;

  public get isSelectionExists(): boolean {
    return !!this.goalPeriod?.reviewPeriodAboutEmployeeResultsId;
  }

  constructor(
    private goalService: GoalService, 
    private router: Router, 
    private msgService: ErrorMessageService,
    private breakpointObserver: BreakpointObserver) {
  
  }

  ngOnInit(): void {
    // Initialization logic here
    this.breakpointObserver.observe(['(max-width: 768px)'])
    .pipe(untilDestroyed(this))
    .subscribe(result => {
      if (result.matches) {
         this.gaugeSize = 100;
         this.gaugeThick = 5;
      } else {
        this.gaugeSize = 62;
        this.gaugeThick = 3;
      }
    });
  }

  public onSelect(item: ReviewPeriodAboutEmployeeResult) {
    this.goalService.selectPanoramaResult(this.goalPeriod.id, item.id).subscribe({
      next: () => {
        // Handle the response here
        RouteHelper.reloadCurrentRoute(this.router);
      },
      error: (err: IResultModel<ResultModel>) => {
        this.msgService.handleError<ResultModel>(err);
      }
    });
  }

  public allowEdit(): boolean {
    return GoalPermissionsHelper.canSelectCompetencyResult(this.goalPeriod);
  }

  public getGaugeValue(item: ReviewPeriodAboutEmployeeResult): number {
    return item.result * 100;
  }

  public isSelected(item: ReviewPeriodAboutEmployeeResult) {
    return this.goalPeriod?.reviewPeriodAboutEmployeeResultsId === item.id;
  }
}